// Third-party
import React, { useState } from 'react';
import uniqueId from 'lodash/uniqueId';
import PerfectScrollbar from 'react-perfect-scrollbar';

// Utils
import { formatMessage } from '@/utils/i18n';

// Images
import { ReactComponent as CsvIcon } from '@/images/csv-icon.svg?react';

// Types
import type { FileUploadError } from '../FileUploaderFlow';

type Props = {
  errors: Array<FileUploadError>;
};

const ErrorStep: React.FC<Props> = ({ errors }) => {
  const [expanded, setExpanded] = useState(false);
  const expandable = uniqueId('expandable-');

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="file-uploader-error-step">
      <div className="file-uploader-inner-wrapper">
        <div className="file-uploader-icon-group">
          <CsvIcon className="file-uploader-csv-icon" />
          <div className="mt-3"> {formatMessage('Modal.PortfolioUpload.Error')}</div>
        </div>
        {errors.length > 5 ? (
          <div className="file-uploader-multi-error-container mt-auto">
            <div className="file-uploader-multi-error">
              <PerfectScrollbar>
                <div className="file-uploader-multi-error-message">
                  <i className="icon-error" />
                  <span>
                    {formatMessage('Modal.PortfolioUpload.MultiError.Message', {
                      errors: errors.length,
                    })}
                  </span>
                </div>
                {expanded && (
                  <ul id={expandable} className="file-uploader-error-list">
                    {errors.map(error => (
                      <li className="file-uploader-error" key={`${error.code}-${error.param || 0}`}>
                        {formatMessage(`Modal.PortfolioUpload.Errors.${error.code}`, {
                          param: error.param || '',
                        })}
                      </li>
                    ))}
                  </ul>
                )}
              </PerfectScrollbar>
            </div>
            <button type="button" className="file-uploader-multi-error-button" onClick={handleExpand} aria-controls={expandable} aria-expanded={expanded}>
              {expanded ? formatMessage('Modal.PortfolioUpload.MultiError.Button.Close') : formatMessage('Modal.PortfolioUpload.MultiError.Button.Expand')}
            </button>
          </div>
        ) : (
          <ul className="file-uploader-error-container mt-auto">
            {errors.map(error => (
              <li className="file-uploader-error" key={`${error.code}-${error.param || 0}`}>
                <i className="icon-error" />

                {formatMessage(`Modal.PortfolioUpload.Errors.${error.code}`, {
                  param: error.param || '',
                })}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ErrorStep;
